import { chartMatch } from './leavys-size-fit.js';

function enhanceFitPages(root = document) {
  root.querySelectorAll('[data-fit-page-chart]').forEach(chart => {
    const helper = chart.querySelector('[data-fit-page-helper]');
    if (!helper || helper.dataset.ready) return;
    helper.dataset.ready = 'true';
    const input = helper.querySelector('[data-fit-page-cm]');
    const output = helper.querySelector('[data-fit-page-result]');
    const rows = [...chart.querySelectorAll('[data-fit-page-row]')];
    const lengths = rows.map(row => row.dataset.footCm);
    const clear = () => {
      rows.forEach(row => { row.classList.remove('lfp-row-match'); row.removeAttribute('aria-current'); });
      output.textContent = '';
      input.removeAttribute('aria-invalid');
    };
    const check = () => {
      clear();
      const match = chartMatch(input.value, lengths);
      if (match.type === 'invalid') input.setAttribute('aria-invalid', 'true');
      match.indexes.forEach(index => { rows[index].classList.add('lfp-row-match'); rows[index].setAttribute('aria-current', 'true'); });
      output.textContent = helper.dataset[match.type]
        .replace('[size]', rows[match.indexes[0]]?.dataset.eu || '')
        .replace('[lower]', rows[match.indexes[0]]?.dataset.eu || '')
        .replace('[upper]', rows[match.indexes[1]]?.dataset.eu || '');
    };
    input.addEventListener('input', clear);
    input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); check(); } });
    helper.querySelector('[data-fit-page-check]').addEventListener('click', check);
    if (chartMatch('1', lengths).type !== 'unavailable') helper.hidden = false;
  });
  root.querySelectorAll('[data-fit-hub]').forEach(hub => {
    const input = hub.querySelector('[data-fit-search]');
    if (!input || input.dataset.ready) return;
    input.dataset.ready = 'true';
    const cards = [...hub.querySelectorAll('[data-fit-brand]')];
    const sections = [...hub.querySelectorAll('[data-fit-brand-section]')];
    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase();
      cards.forEach(card => { card.hidden = !card.dataset.fitBrand.includes(query); });
      sections.forEach(section => { section.hidden = ![...section.querySelectorAll('[data-fit-brand]')].some(card => !card.hidden); });
      hub.querySelector('[data-fit-empty]').hidden = cards.some(card => !card.hidden);
    });
    hub.querySelector('[data-fit-search-wrap]').hidden = false;
  });
}

enhanceFitPages();
document.addEventListener('shopify:section:load', event => enhanceFitPages(event.target));
